import { api } from "./api";

export interface McpServer {
  id: string;
  org_id: string;
  name: string;
  url: string;
  headers: Record<string, string>;
  allowed_tools: string[];
  created_by: string;
  created_at: string;
}

export type McpCreateData = Omit<McpServer, "id" | "org_id" | "created_by" | "created_at">;
export type McpUpdateData = Partial<McpCreateData>;

export const mcpService = {
  list: (orgId: string) => api.get<McpServer[]>(`/orgs/${orgId}/mcps`),
  create: (orgId: string, data: McpCreateData) =>
    api.post<McpServer>(`/orgs/${orgId}/mcps`, data),
  update: (orgId: string, mcpId: string, data: McpUpdateData) =>
    api.put<McpServer>(`/orgs/${orgId}/mcps/${mcpId}`, data),
  delete: (orgId: string, mcpId: string) =>
    api.delete(`/orgs/${orgId}/mcps/${mcpId}`),
};
